/**
 * 브랜드 허브 상세가 나뉘는 면 — 값은 `constants/brand-hub-options` 한 곳이다(조건표와 함께 읽는다).
 */

export { BRAND_HUB_FACES } from 'src/constants/brand-hub-options';
export type { BrandFace } from 'src/constants/brand-hub-options';
